import React, {Fragment, useEffect, useState} from "react";
import {getPost} from "../../../redux/actions";
import {Featured} from "./Featured";

export const Read = ({get_id, path, pages}) => {

    // console.log(get_id);

    const [post, setPost] = useState({});
    // const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {

        const fetchData = async () => {

            // start loading
            // setIsLoading(true);

            // clear all
            setPost({});

            try {

                window.scrollTo(0, 0);

                // get post
                const result = await getPost(get_id);

                // set post
                setPost(result.data);

            } catch (e) {

                // show errors
                console.log('error', e);
            }

            // stop loading
            // setIsLoading(false);
        };

        // noinspection JSIgnoredPromiseFromCall
        fetchData();

    }, [get_id]);

    return (
        <Fragment>
            <Featured
                post={post}
                read={true}
                pages={pages}
                path={path}
            />
            <div className={'post-read'} dangerouslySetInnerHTML={{__html: post.body}}/>
        </Fragment>
    );
};